/**
 * in this module there are all the related functions for:
 *  - create the tro legend
 *  - create the fra legend
 *  - the creation of the scheme for PC
 *  - create the pc legend
 */

/**
 * import modules
 */

import overlay from './overlay'
import pccomments from '../parkmap/pccomments'
import layers from '../parkmap/pmlayers'
import pclayers from '../parkmap/pclayers'
import map from './map'
import amlayers from '../accsmap/amlayers'
import invlayers from '../invmap/invlayers'
import functions from './functions'
import psalayers from '../frastaff/fralayers'
import fralayers from '../psastaff/psalayers'
import Cookies from './cookies'
/**
 * get the settings from settings.json
 */

const initLegend = () => {
  let pageconfig = JSON.parse($('#pageconfig').val())
  if (pageconfig.appname.type === 'consult') {
    // special public consultation legend
    buildSchemeList()
    buildPCLegendList()
  }
  else {
    // Universal Traffweb Legend
    buildLegendList()
  }
}

/**
 * build the TRO legend
 */

const buildLegendList = () => {

  // in the blade the default is checked on
  // to initialise turn off any elements not selected
  // by default
  let theSel = $('#featclick').val().split(',')
  let accSel = $('#rtcfeatclick').val().split(',')
  let invSel = $('#invfeatclick').val().split(',')
  let frapsasel = $('#frapsafeatclick').val().split(',')
  //hide any empty grouplists (can be caused by private layers not being displayed)
  $('.grouplist').each(function () {
      if ($(this).children().length === 0) {
        let buttonName = $(this).attr('data-button')
        $('#' + buttonName).css('display','none')
      }
  })

  $('.grouplist input[type=checkbox]').each(function () {

      if ($(this).val() === 'accsmap') {
        if (accSel.indexOf("'"  + $(this).attr('data-order') + "'") === -1) {
          // check off
          $(this).prop('checked', false)
        }
      } else if ($(this).val() === 'invmap') {
        if (invSel.indexOf($(this).attr('data-order')) === -1) {
          // check off
          $(this).prop('checked', false)
        }
      } else if ($(this).val() === 'fra' || $(this).val() === 'psa') {
        if (frapsasel.indexOf($(this).attr('data-order')) === -1) {
            // check off
            $(this).prop('checked', false)
          }
      } else {
        if (theSel.indexOf($(this).attr('data-order')) === -1) {
          // check off
          $(this).prop('checked', false)
        }
      }
  })


  /**
   * click event listener on each label
   * show/hide restriction in the map based on which restriction you click in the legend
   */
  $('.groupbtn').on('click', function () {
     /**
       * create a $this variable
       * assign to tmp the actual ID of the button
       */
      let tmp = ''
      const $this = $(this)
      tmp = $this.attr('id')

      /**
       * hide the popup
       */

      overlay.overlay.setPosition(undefined)

      /**
       * check the value of the button
       */

      if ($this.val() === 'on') {
        /**
         * if is ON change the value to OFF
         */

        $this.val('off')

        /**
         * hide the related list
         * change the check box icon to X
         * change all the restrictons in the list to OFF and remove the class fa-times
         */

        $(`#${tmp}_list`).hide()
        $(this).children('em').addClass('fa-times').removeClass('fa-check')
        $(`#${tmp}_list input[type=checkbox]`).prop('checked', false)
      }
      else {
        /**
         * if is OFF change the value to ON
         * assign to tmp the actual ID of the button
         */

        $this.val('on')

        /**
         * show the related list
         * change the check box icon to V
         * change all the restrictons in the list to ON and add the class fa-times
         */

        $(`#${tmp}_list`).show()

        $(this).children('em').addClass('fa-check').removeClass('fa-times')
        $(`#${tmp}_list input[type=checkbox]`).prop('checked', true)
      }

      /**
       * get all the active restrictions
       * save it as a val of #featclick
       *  - we use it to update the layer parameters from the datepicker
       */

      const tmpsOrderSel = []
      const tmpsAccSel = []
      const tmpsInvSel = []
      const tmpsFraPsaSel = []

      $('.grouplist input[type=checkbox]:checked').each(function () {
        if ($(this).val() === 'accsmap') {
          tmpsAccSel.push("'" + $(this).attr('data-order')+ "'")
        } else if ($(this).val() === 'invmap') {
          tmpsInvSel.push($(this).attr('data-order'))
        } else if ($(this).val() === 'fra' || $(this).val() === 'psa') {
            tmpsFraPsaSel.push($(this).attr('data-order'))
        } else {
          tmpsOrderSel.push($(this).attr('data-order'))
        }
      })

      $('#featclick').val(tmpsOrderSel)
      $('#rtcfeatclick').val(tmpsAccSel)
      $('#invfeatclick').val(tmpsInvSel)
      $('#frapsafeatclick').val(tmpsFraPsaSel)
      /**
       * update the pmfeatlayer with the new value
       */

      layers.updateLayerParams(tmpsOrderSel, 0)
      psalayers.updateLayerParams(tmpsFraPsaSel, 0)
      fralayers.updateLayerParams(tmpsFraPsaSel, 0)
      amlayers.updateLayerParams()
      invlayers.updateInvLayerParams()
    /**
     * end button click
     */
  })

  /**
   * click event listener on each icon
   * show/hide restriction in the map based on which restriction you click in the legend
   */

  $('.grouplist input[type=checkbox]').on('click', function (e) {

    /**
     * hide the popup
     */

    overlay.overlay.setPosition(undefined)

    /**
     * get all the active restrictions
     * save it as a val of #featclick
     *  - we use it to update the layer parameters from the datepicker
     */

    const tmpsOrderSel = []
    const tmpsAccSel = []
    const tmpsInvSel = []
    const tmpsFraPsaSel = []
    $('.grouplist input[type=checkbox]:checked').each(function () {
      if ($(this).val() === 'accsmap') {
        tmpsAccSel.push("'" + $(this).attr('data-order')+ "'")
      } else if ($(this).val() === 'invmap') {
        tmpsInvSel.push($(this).attr('data-order'))
    } else if ($(this).val() === 'fra' || $(this).val() === 'psa') {
        tmpsFraPsaSel.push($(this).attr('data-order'))
      } else {
        tmpsOrderSel.push($(this).attr('data-order'))
      }
    })

    $('#featclick').val(tmpsOrderSel)
    $('#rtcfeatclick').val(tmpsAccSel)
    $('#invfeatclick').val(tmpsInvSel)
    $('#frapsafeatclick').val(tmpsFraPsaSel)
    /**
     * update the featlayer with the new value
     */

    layers.updateLayerParams(tmpsOrderSel, 0)
    amlayers.updateLayerParams()
    invlayers.updateInvLayerParams()
    fralayers.updateLayerParams(tmpsFraPsaSel, 0)
    psalayers.updateLayerParams(tmpsFraPsaSel, 0)
  })

  /**
   * dipslay just predetermined group with parameters in the URL
   * run it with a timeout function to render and then click each button
   */

  /**
   * check if there is a parameters in the URL
   * check if the parameter is group and not other parameters like defpos
   */

  const urlGroup = window.location.search.replace('?', '')

  if (urlGroup.search('group=') > -1) {
    /**
     * run everything with a timeout to let the legend time to be rendered
     */

    setTimeout(() => {
      /**
       * replace the spaces in the group name with an _ underscore and click all the buttons
       */
      /**
       * check which group has to be displayed
       * we check if splitting by & you have something back
       * based on that we take the correct parameter and we split it by /
       * we split by / to allow the customer to display more than one group at the same time
       * e.g. defpos + legend group
       * e.g. group=signs/prohibition/speed%20limits/virtual%20loading%20bay
       */

      let groupToShow = ''

      if (urlGroup.split('&')[1]) {
        groupToShow = decodeURIComponent(urlGroup).toLowerCase().split('=')[2].split('/')
      }
      else {
        groupToShow = decodeURIComponent(urlGroup).toLowerCase().split('=')[1].split('/')
      }
      $('.feature_group').each(function(){
        if (groupToShow.indexOf($(this).text().toLowerCase()) == -1 ) {
            $(this).click()
        }
      })
    }, 800)

  /**
   * end if urlGroup
   * end legend function
   */
  }

  if (window.location.href.indexOf('sefton') > -1) { //sefton
    /**
     * run everything with a timeout to let the legend time to be rendered
     */

    setTimeout(() => {
      /**
       * replace the spaces in the group name with an _ underscore and click all the buttons
       */
      $("button:contains('Speed Limits')").click()
    }, 800)
  }
}

/**
 * build the scheme list for public consultation
 */

const buildSchemeList = () => {
  /**
   * initialize
   */
 /**
   * get the main element where we will append the scheme list
   */

  let collapsibleSet = $('.schemeHead')
  /**
   * click event listener on each title
   */
   $('.schemeHead').on('click', function(e){
    e.preventDefault()
    e.stopPropagation()
    let schemeid =parseInt($(this).attr("data-schemeid"))
    $('#currentscheme').val(schemeid)
    if ($(this).attr("data-speed")) {
        $('#select_layers').css('display','none')
    } else {
        $('#select_layers').css('display','block')
    }
    pclayers.updateLayerScheme(schemeid)
   })

    $('.schemeHead .doc').on('click', function(){
      window.open($(this).attr('href'), '_blank')
    })

  $('.schemeHead h5').on('click', function () {
    /**
     * reset all the lists to close
     */
    $('.schemeHead h5 em').removeClass('fa-caret-down').addClass('fa-caret-right')
    $('.schemeHead ul').css('display', 'none')

    /**
     * open/close the list
     * change the arrow icon at the end of the text
     * move the map
     */
    $(this).next('.streetname').toggle()
    $(this).children('em').toggleClass('fa-caret-right fa-caret-down')
    $(`#${$(this).parent().attr('id')}`).find('.viewentirescheme:first').trigger('click')

    /**
     * change the value of the comment buttons
     */
    $('#markercomment').val($(this).parent().attr('id'))

    if ($(this).parent().attr('id') % 1000) {
      $('#markercomment').css('display', 'block')
    } else {
      $('#markercomment').css('display', 'none')

    }
    if ($(this).parent().attr('id') % 1000) {
      $('.slidecontainer').css('display', 'block')
    }
    else {
      $('.slidecontainer').css('display', 'none')
    }

    /**
     * hide all the legend and display just the related with the scheme
     */

    let legids = $(`#${$(this).parent().attr('id')}`).find('.viewentirescheme:first').attr('data-legids')
    $('.pcLegend li').not($('.Comments')).not($('.Views')).addClass('d-none')
    if (legids) {
      legids.split(',').forEach(function (element) {
        $(`#li${element}`).removeClass('d-none')
      })
    }

  /**
   * end $('.schemeHead h5').on('click'
   */
  })

  /**
   * keypress event listener on each title
   * accessibility compliance
   */

  $('.schemeHead h5').keypress(function (e) {
    if (e.which === 13) {
      $(this).next('.streetname').toggle()
      $(this).children('em').toggleClass('fa-caret-right fa-caret-down')
    }
  })

  /**
   * click event listener on the view entire scheme button
   */

  $('.viewentirescheme').on('click', function () {
    let myPos = $(this).attr('data-defpos').split(',')
    map.getMap().getView().animate({resolution: map.getResolution()[parseInt(myPos[2])]}, {center: [parseInt(myPos[0]), parseInt(myPos[1])]})
    let strExt = $(this).attr('data-extent').split(',')
    let cleanExt = [parseInt(strExt[0]), parseInt(strExt[1]), parseInt(strExt[2]), parseInt(strExt[3])]
    map.setSchemeExtents(cleanExt, $(this).attr('data-defpos').split(','))
    map.getMap().updateSize()

    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  })

  /**
   * click event listener on each street name
   */

  $('.streetnameli').on('click', function () {

    map.getMap().getView().animate({resolution: map.getResolution()[parseInt(map.getResolution().length - 1)]}, {center: [parseInt($(this).attr('data-easting')), parseInt($(this).attr('data-northing'))]})
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  })

  /**
   * open the first scheme as default or selected scheme sotred in msg_selected_scheme
   */

  setTimeout(function () {
    if ($('#msg_selected_scheme').length > 0) {
      let thectl = $('#msg_selected_scheme').val()
      // get cookie coords
      var CookieSettings = Cookies.getUserPrefs()
      let setPos = [0]
      if (CookieSettings) {
        setPos = CookieSettings.split(',')
      }
      $('#schemehead_' + thectl + ' h5').trigger('click')
      if (setPos[0] !== 0) {
        map.getMap().getView().setResolution(parseFloat(setPos[2]))
        map.getMap().getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], map.getMap().getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
      }
    } else if ($('#defaultScheme').val() != '') {
      let thectl = $('#defaultScheme').val()
      // get cookie coords
      var CookieSettings = Cookies.getUserPrefs()
      let setPos = [0]
      if (CookieSettings) {
        setPos = CookieSettings.split(',')
      }
      $('#schemehead_' + thectl + ' h5').trigger('click')
      if (setPos[0] !== 0) {
        map.getMap().getView().setResolution(parseFloat(setPos[2]))
        map.getMap().getView().centerOn([parseFloat(setPos[0]), parseFloat(setPos[1])], map.getMap().getSize(), [($('#map').innerWidth() / 2), ($('#map').innerHeight() / 2)])
      }
    } else {
       $(`#${collapsibleSet[0].id} h5`).trigger('click')
    }

  }, 300)


} // end buildSchemeList

/**
 * public consultation legend
 */

const buildPCLegendList = () => {
  /**
   * show the public consultation legend
   * hide the TRO switchdisplay div
   */

  $('#pcLegend').show()
  $('#switchdisplay').hide()

  // street lighting layer only
  $('#streetlight').on('click', function() {
    pclayers.changePCLayer($("#select_layers option:selected").val())
  })
  $('#strategiclayer').on('click', function() {
    pclayers.changePCLayer($("#select_layers option:selected").val())
  })
  // select val for change the layers
  $('#select_layers').on('change', function () {
    /**
     * get the value of the selected layer
     * assing it to a var
     * update the parkmap layer parameter
     * hide the popup
     */
    // hide the menu if is a mobile
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
    const $this = this.value
    pclayers.changePCLayer($this)

    overlay.overlay.setPosition(undefined)
  })

  $("#schemesearch").on("keypress", function(e) {
    if (e.keyCode  === 13) {
        //
        if ($('#schemeresults').length === 0)
        {
            return
        } else {
            if ($('li.scheme-key-sel').length > 0) {
                $('#schemesearch').val($('li.scheme-key-sel').text())
                $('li.scheme-key-sel').trigger('click')
            } else {
                //get first element update text and click
                $('#schemesearch').val($('#schemeresults li').first().text())
                $('#schemeresults li').first().trigger('click')
            }
        }
    }
    })

    $("#schemesearch").on("keydown", function(e) {
        if (e.keyCode  === 38 || e.keyCode  === 40) { //up / down
            let listlength = $('#schemeresults li').length
            let cursel = 0
            if ($('li.scheme-key-sel').length > 0) {
                cursel = parseInt($('li.scheme-key-sel').index())
                if (e.keyCode  === 40) {
                    cursel += 1
                    if (cursel > (listlength -1)) {
                        cursel = 0
                    }
                } else if (e.keyCode  === 38) {
                    cursel -= 1
                    if (cursel < 0) {
                        cursel = (listlength -1)
                    }
                }
                $('#schemeresults li').removeClass('scheme-key-sel')
                $('#schemeresults li:eq('+cursel+')').addClass('scheme-key-sel')
                $('#schemesearch').val($('#schemeresults li:eq('+cursel+')').text())
            } else {
                $('#schemeresults li:eq(0)').addClass('scheme-key-sel')
                $('#schemesearch').val($('#schemeresults li:eq(0)').text())
            }

        }
    })
  $("#schemesearch").on("keyup", function(e) {
    if (e.keyCode  === 38 || e.keyCode  === 40 || e.keyCode  === 13) {return}
    let foundList = []
    $('#schemeresults').remove()
    $('#schemes h5').each(function() {
        let value = $('#schemesearch').val().toLowerCase()
        if (value.length < 3) {return}
        if($(this).text().toLowerCase().indexOf(value) > -1) {
            foundList.push($(this).text())
        }

    })
    $('#schemes li').each(function() {
        let value = $('#schemesearch').val().toLowerCase()
        if (value.length < 3) {return}
        if($(this).find('p').text().toLowerCase().indexOf(value) > -1) {
            foundList.push($(this).text())
        }
    })

    /// proces results
    if (foundList.length > 0) {
        $('#schemeresults').remove()
        var schemeresults = $('<ul id="schemeresults" class="scheme-results" />')
        foundList.forEach(function(ele){
            $('<li>' + ele + '</li>').appendTo(schemeresults).click(function() {
                    let locate = $(this).text()
                    if ($('#schemes h5:contains('+locate+')').first().length > 0) {
                        //find scheme
                        $('#schemes h5:contains('+locate+')').first().trigger('click')

                    }
                    if ($('#schemes p:contains('+locate+')').first().length > 0) {
                        //find street in scheme
                        // get ids
                        let findid = $('#schemes p:contains('+locate+')').first().attr('id')
                        let schemefound = $('#schemes p:contains('+locate+')').first().attr('data-schemeid')
                        //open the scheme section - dont use click as it will trigger map rerdaw
                        $(`#schemehead_${schemefound} h5 em`).trigger('click')
                        $(`#schemehead_${schemefound} ul`).css('display', 'block')
                        //SCROLL STREET NAME INTO VIEW AND CLICK ON STREET
                        $(`#${findid}`)[0].scrollIntoView()
                        $(`#${findid}`).trigger('click')
                    }
                    //hide and remove
                    $('#schemeresults').css('display','none')
                    $('#schemeresults').remove()
                }
            ).hover(function() {
                $('#schemeresults li').removeClass('scheme-key-sel')
            })
        })


        $('#schemeresultscontainer').append(schemeresults)
        let swidth = $('#schemesearch').outerWidth()
        $('#schemeresults').css('width',swidth)
        $('#schemeresults').css('display','block')
    }
})
  /**
   * initialise form
   */
   //pccomments.initPcForm()
} // end buildPCLegendList


/**
 * EXPORT
 */

export default {
  initLegend,
  buildLegendList
}
